<template
  @click:outside="closeThisMenu"
>
  <v-menu
    v-model="isMenuOpen"
    bottom
    left
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        icon
        v-bind="attrs"
        v-on="on"
      >
        <v-icon>mdi-dots-vertical</v-icon>
      </v-btn>
    </template>

    <v-list>
      <v-list-item
        v-if="canWrite"
        @click="editModalClick"
      >
        <v-list-item-title>
          <v-icon
            left
            small
          >
            mdi-pencil
          </v-icon>
          Modifica
        </v-list-item-title>
      </v-list-item>
      <v-list-item
        v-if="canManagePermissions"
        @click="permissionsModalClick"
      >
        <v-list-item-title>
          <v-icon
            left
            small
          >
            mdi-lock
          </v-icon>
          Permessi
        </v-list-item-title>
      </v-list-item>
      <v-list-item
        v-if="canDelete"
        @click="deleteModalClick"
      >
        <v-list-item-title>
          <v-icon
            left
            small
          >
            mdi-delete
          </v-icon>
          Elimina
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>

import { can } from '@core/libs/acl/utils'

export default {
  name: 'FolderMenu',
  props: {
    folderData: {
      type: Object,
      required: true,
    },
    showMenu: {
      type: Boolean,
      required: false,
    },
    canWrite: {
      type: Boolean,
      required: false,
      default: true,
    },
    canDelete: {
      type: Boolean,
      required: false,
      default: true,
    },
    canManagePermissions: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data() {
    return {
      isMenuOpen: false,
    }
  },
  watch: {
    showMenu(newVal) {
      this.isMenuOpen = newVal
    },
    isMenuOpen(newVal) {
      if (newVal === false) {
        this.$emit('closeMenu')
      }
    },
  },
  methods: {
    can,
    editModalClick() {
      this.$emit('closeMenu')
      this.$emit('editDocument')
    },
    permissionsModalClick() {
      this.$emit('closeMenu')
      this.$emit('permissionsFolder')
    },
    deleteModalClick() {
      this.$emit('closeMenu')
      this.$emit('deleteDocument')
    },
    closeThisMenu() {
      this.$emit('closeMenu')
    },
  },
}
</script>
